export default {"src":"/_next/static/media/person_24.4ff9e70d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};